import { render, staticRenderFns } from "./AlunosPorTurma.vue?vue&type=template&id=7c5270b3&scoped=true&"
import script from "./AlunosPorTurma.vue?vue&type=script&lang=js&"
export * from "./AlunosPorTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5270b3",
  null
  
)

export default component.exports